import React, {useCallback} from 'react';
import UCustomScrollBar from 'ubs-framework/v2/UCustomScrollBar';
import UNoDataFound from 'ubs-framework/v2/UErrorPages/UNoDataFound';
import {useSelector} from "react-redux";
import {CONSTANT, PROFILE_SECTION} from "ubs-framework/v2/common/constant";
import UDateFormatter from "ubs-framework/v2/Udate-formatter";
import {getLabelValue} from "ubs-framework/v2/common/function";
import {EXPECTED_CTC_TYPE} from "../../../../../common/constant";
import { useFieldLabel } from 'ubs-framework/v2/hooks/useCustomFieldConfig';

const SuccessDataTable = React.memo((props) => {
    const _SL = useSelector(e => getLabelValue(e?.hrms?.sourceList));
    const _A_LT = useSelector(e => getLabelValue(e?.hrms?.branchList));
    const _A_JTL = useSelector(e => getLabelValue(e?.hrms?.jobTitleList));
    const getLabel = useFieldLabel();

    return (
        <React.Fragment>
            <UCustomScrollBar>
                <div className="u_table-resource u_table-resource-nowrap u_table-resource-hover u_table-resource-no-sticky u_text-left">
                    <table>
                        <thead className="u_table-resource-header">
                        <tr>
                            <th>{getLabel(PROFILE_SECTION.basicInfo, 'candidateId', 'Candidate ID')}</th>
                            <th>{getLabel(PROFILE_SECTION.basicInfo, 'firstName', 'First Name')}</th>
                            <th>{getLabel(PROFILE_SECTION.basicInfo, 'lastName', 'Last Name')}</th>
                            <th>{getLabel(PROFILE_SECTION.emergencyContact, 'email', 'Email')}</th>
                            <th>{getLabel(PROFILE_SECTION.basicInfo, 'dob', 'Date of Birth')}</th>
                            <th>Contact Number</th>
                            <th>{getLabel(PROFILE_SECTION.jobInfo, 'jobTitle', 'Job Title')}</th>
                            <th>{getLabel(PROFILE_SECTION.basicInfo, 'gender', 'Gender')}</th>
                            <th>{getLabel(PROFILE_SECTION.jobInfo, 'location', 'Location')}</th>
                            <th>{getLabel(PROFILE_SECTION.previousEmployee, 'workExperience', 'Total Experience')}</th>
                            <th>Current CTC</th>
                            <th>Expected CTC Type</th>
                            <th>Expected CTC</th>
                            <th>Expected CTC Range From</th>
                            <th>Expected CTC Range To</th>
                            <th>{getLabel(PROFILE_SECTION.compensationInfo, 'noticePeriod', 'Notice Period (In Days)')}</th>
                            <th>Reason to Change</th>
                            <th>{getLabel(PROFILE_SECTION.contactSocial, 'skype', 'Skype ID')}</th>
                            <th>{getLabel(PROFILE_SECTION.contactSocial, 'linkedIn', 'LinkedIn URL')}</th>
                            <th>Source</th>
                            <th>Portfolio Links</th>
                        </tr>
                        </thead>

                        <tbody>
                        {props?.successData?.map((data, i) => {
                            return (
                                <tr key={i}>
                                    <td>{data?.['candidateId'] || '-'}</td>
                                    <td>{data?.['firstName'] || '-'}</td>
                                    <td>{data?.['lastName'] || '-'}</td>
                                    <td>{data?.['email'] || '-'}</td>
                                    <td>{<UDateFormatter date={data?.dob}/>}</td>
                                    <td>{data?.['contactNo'] || '-'}</td>
                                    <td>{data?.['job'] || '-'}</td>
                                    <td>{data?.gender || '-'}</td>
                                    <td>{data?.location || '-'}</td>
                                    <td>{data?.['experience'] || '-'}</td>
                                    <td>{data?.['currentCtc'] || '-'}</td>
                                    <td>{EXPECTED_CTC_TYPE?.find(_ => _?.value === data?.expectedCtcType)?.label || '-'}</td>
                                    <td>{data?.['expectedCtc'] || '-'}</td>
                                    <td>{data?.['expectedCtcFrom'] || '-'}</td>
                                    <td>{data?.['expectedCtcTo'] || '-'}</td>
                                    <td>{data?.['noticePeriod'] || '-'}</td>
                                    <td>{data?.reasonToChange || '-'}</td>
                                    <td>{data?.['skypeId'] || '-'}</td>
                                    <td>{data?.['linkedIn'] || '-'}</td>
                                    <td>{data?.['source'] || '-'}</td>
                                    <td>{data?.['portfolioLinks'] || '-'}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                    {props?.successData?.length === 0 && <UNoDataFound width={300} image="/images/no-data-found.svg" message="No data to display"/>}
                </div>
            </UCustomScrollBar>
        </React.Fragment>
    );
});

export default SuccessDataTable;
